export default __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo-2-725a1416d526fab39f477621f11e6e69.png";